import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import './EmojiPicker.css';

function EmojiPicker({ isOpen, onClose, onEmojiSelect, referenceElement }) {
  const [popperElement, setPopperElement] = useState(null);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
  placement: 'auto', // preferred position
  modifiers: [
    {
      name: 'flip',
      options: {
        fallbackPlacements: ['bottom', 'right', 'left'], // allow more flexibility
      },
    },
    {
      name: 'preventOverflow',
      options: {
        boundary: 'viewport',
        padding: 8,
      },
    },
    {
      name: 'offset',
      options: {
        offset: [0, 10],
      },
    },
  ],
});

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popperElement && !popperElement.contains(event.target)) {
        // Don't close if clicking the reference element
        if (referenceElement && referenceElement.contains(event.target)) {
          return;
        }
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      // Small delay to ensure the picker is mounted before adding listeners
      const timer = setTimeout(() => {
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
      }, 100);

      return () => {
        clearTimeout(timer);
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleEscape);
      };
    }
  }, [isOpen, onClose, popperElement, referenceElement]);

  if (!isOpen || !referenceElement) return null;

  return createPortal(
    <div
      ref={setPopperElement}
      style={styles.popper}
      {...attributes.popper}
      className="emoji-picker-wrapper"
    >
      <div className="emoji-picker-container">
        <Picker
          data={data}
          onEmojiSelect={(emoji) => {
            // Use emoji shortcode without colons for Slack API
            const emojiCode = emoji.id || emoji.shortcodes || emoji.native;
            onEmojiSelect(emojiCode);
          }}
          theme="light"
          previewPosition="none"
          skinTonePosition="none"
          searchPosition="top"
          perLine={7}
          maxFrequentRows={1}
          autoFocus={true}
          emojiSize={20}
          emojiButtonSize={28}
        />
      </div>
    </div>,
    document.body
  );
}

export default EmojiPicker;